import { Grid } from "@mui/material";
import React from "react";
import { useAuth } from "../../../../../hooks";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import { capitalizeFirstLetter } from "../../../../../constants";

const GAUserDetailsDataFieldsSection = ({
  userDetails,
  setUserDetails,
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  providerType,
}) => {
  const { currentUser } = useAuth();
  const userTypeOptions = ["user", "teacher", "student", "owner", "member"];

  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Photo"}
          image={userDetails?.photoUrl}
          // image={images.tableDummyImage}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          details={userDetails}
          setDetails={setUserDetails}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
        />
        {/*FIrst Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"First Name"}
          value={userDetails.firstName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              firstName: e.target.value,
            })
          }
        />
        {/*Last Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Last Name"}
          value={userDetails.lastName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              lastName: e.target.value,
            })
          }
        />
        {/*username section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Username"}
          value={userDetails.userName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              userName: e.target.value,
            })
          }
        />
        {/*username section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Email"}
          value={userDetails?.email}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              email: e.target.value,
            })
          }
        />
        {/*provider Type section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Provider Type"}
          value={providerType ?? ""}
          disabled={true}
          // editEnabled={editEnabled}
        />

        {/*user type section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"User Type"}
          value={(userDetails?.type ?? "user").toLowerCase()}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={userTypeOptions}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              type: (e.target.value || "user").toLowerCase(),
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*qt Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Account Status"}
          value={
            userDetails.isActive === true
              ? "active"
              : userDetails.isActive === false
              ? "inactive"
              : undefined
          }
          disabled={true}
          // editEnabled={editEnabled}
          editEnabled={
            editEnabled && currentUser?.role === "super" ? editEnabled : false
          }
          select={true}
          dropdownValues={["active", "inactive"]}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              isActive: e.target.value === "active" ? true : false,
            })
          }
        />
        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"About Me"}
          value={userDetails.about}
          disabled={true}
          multiline={true}
          rows={4}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              about: e.target.value,
            })
          }
        />
        {/*link section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Link"}
          value={userDetails?.link}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setUserDetails({
              ...userDetails,
              link: e.target.value,
            })
          }
        />
        {/*reported status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Status"}
          value={capitalizeFirstLetter(userDetails?.reportedStatus)}
          disabled={true}
          // editEnabled={editEnabled}
          // onChange={(e) =>
          //   setUserDetails({
          //     ...userDetails,
          //     reportedStatus: e.target.value,
          //   })
          // }
        />
        {/*user id section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"User ID"}
          value={userDetails?.id}
          disabled={true}
          // editEnabled={editEnabled}
          // onChange={(e) =>
          //   setUserDetails({
          //     ...userDetails,
          //     reportedStatus: e.target.value,
          //   })
          // }
        />
      </Grid>
    </Grid>
  );
};

export default GAUserDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
